import 'angular:locale/data:en-US';
import 'zone.js';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "en-US";
